export default __webpack_public_path__ + "static/media/offer1.d3dc665e.png";